import { RespCategory } from '@vas2t-lowcode/api';
import mitt, { Emitter } from 'mitt';

let _templateTypeEmitter: Emitter<{ 'on-app-search-by-key': string; 'on-template-type-click': RespCategory }>;

/** myApp 事件总池 */
export const getTemplateTypeEmitter = () => {
  return _templateTypeEmitter || (_templateTypeEmitter = mitt());
};
